import styles from "@styles/Icons.module.css";
import { CSSProperties, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import lottie, { AnimationItem } from "lottie-web";
import { assetPath } from "@utils/Config";

type IconProps = {
    color: CSSProperties["color"];
    rotation?: number;
}

type LottieProps = IconProps & {
    loop?: boolean;
    autoplay?: boolean;
}

export function Home({ color, rotation = 0 }: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%">
            <g className={styles.transform} transform={`rotate(${rotation})`} style={{ fill: color, stroke: color }}>
                <polygon className={`${styles.icon} ${styles.stroke}`} points="23.0975 82.6775 60.0098 103.9381 60.0098 58.8851 23.0975 37.9367 23.0975 82.6775" />
                <polygon className={`${styles.icon} ${styles.stroke}`} points="23.3147 37.8175 59.948 16.0619 96.8511 37.6498 60.0098 58.8851 23.3147 37.8175" />
                <polygon className={`${styles.icon} ${styles.stroke}`} points="60.0098 58.8851 96.9025 37.9367 96.9025 82.3654 60.0098 103.9381 60.0098 58.8851" />
                <line className={`${styles.icon} ${styles.stroke}`} x1="43.056" y1="26.1249" x2="80.2599" y2="47.4585" />
            </g>
        </svg>
    );
}

export function Details({ color, rotation = 0 }: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%">
            <g className={styles.transform} transform={`rotate(${rotation})`} style={{ fill: color, stroke: color }}>
                <polyline className={`${styles.icon} ${styles.stroke}`} points="23.0225 61.0323 23.0225 87.9491 59.9348 109.2097 59.9348 64.1567 23.0225 43.2083" />
                <polygon className={`${styles.icon} ${styles.stroke}`} points="23.2398 43.0891 59.873 21.3335 96.7762 42.9214 59.9348 64.1567 23.2398 43.0891" />
                <polygon className={`${styles.icon} ${styles.stroke}`} points="59.9348 64.1567 96.8275 43.2083 96.8275 87.637 59.9348 109.2097 59.9348 64.1567" />
                <polyline className={`${styles.icon} ${styles.stroke}`} points="23.2398 43.0891 6.2355 50.9567 43.4393 72.2903 59.9348 64.1567" />
                <polyline className={`${styles.icon} ${styles.stroke}`} points="59.873 21.3335 76.5607 10.7903 113.7645 32.1239 96.7762 42.9214" />
                <line className={`${styles.icon} ${styles.stroke}`} x1="60.008" y1="63.6558" x2="59.873" y2="21.3335" />
            </g>
        </svg>

    );
}

export function Temperature({ color, rotation = 0 }: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%">
            <g className={styles.transform} transform={`rotate(${rotation})`} style={{ fill: color, stroke: color }}>
                <path className={`${styles.icon} ${styles.stroke} ${styles.thin}`} d="M60,60v14.8389-24.8389Z" />
                <path className={`${styles.icon} ${styles.stroke}`} d="M70,68.0977V30.968c0-5.5229-4.4775-10-10-10s-10,4.4771-10,10v37.1297c-4.2902,3.1093-7.0967,8.1463-7.0967,13.8376,0,9.4268,7.6699,17.0967,17.0967,17.0967s17.0967-7.6699,17.0967-17.0967c0-5.6913-2.8065-10.7283-7.0967-13.8376Z" />
                <circle className={`${styles.icon} ${styles.fill}`} cx="60" cy="81.9356" r="7.0968" />
            </g>
        </svg>
    );
}

export function Metrics({ color, rotation = 0 }: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%">
            <g className={styles.transform} transform={`rotate(${rotation})`} style={{ fill: color, stroke: color }}>
                <line className={`${styles.icon} ${styles.stroke}`} x1="34.0645" y1="101.1613" x2="34.0645" y2="65.2903" />
                <line className={`${styles.icon} ${styles.stroke}`} x1="51.0968" y1="101.1613" x2="51.0968" y2="39.2258" />
                <line className={`${styles.icon} ${styles.stroke}`} x1="68.6452" y1="101.1613" x2="68.6452" y2="18.8387" />
                <line className={`${styles.icon} ${styles.stroke}`} x1="85.9355" y1="101.1613" x2="85.9355" y2="50.0645" />
            </g>
        </svg>
    );
}

export function Arrow({ color, rotation = 0 }: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%">
            <g className={styles.transform} transform={`rotate(${rotation})`} style={{ fill: color, stroke: color }}>
                <polyline className={`${styles.icon} ${styles.stroke}`} points="42.8572 100 77.1429 60 42.8571 20" />
            </g>
        </svg>
    );
}

export function DSSmith() {
    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
            <defs>
                <clipPath id="b">
                    <path d="M99.5651,99.5579h0c0,54.7407,14.705,106.0181,40.2811,150.2151,51.9421,89.7861,148.9579,150.215,260.1489,150.215s208.1779-60.4289,260.1538-150.215c-51.9758-89.7716-148.9627-150.2151-260.1538-150.2151H99.5651Z" style={{ fill: "none" }} />
                </clipPath>
                <radialGradient id="c" cx="-3355.8895" cy="688.6929" fx="-3355.8895" fy="688.6929" r="4.8166" gradientTransform="translate(87547.482 424394.0007) rotate(90) scale(126.4813)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#f9b233" />
                    <stop offset=".2384" stopColor="#f9b233" />
                    <stop offset=".8817" stopColor="#e6332a" />
                    <stop offset="1" stopColor="#e6332a" />
                </radialGradient>
                <clipPath id="d">
                    <path d="M399.9951,399.988v.0096c-111.191,0-208.2068,60.4435-260.1489,150.2151-25.2678,43.6913-39.9344,94.2848-40.2811,148.3124,7.9136-44.2982,32.7624-85.822,53.9699-122.4522,51.9325-89.7813,148.9579-150.2102,260.1393-150.2102,134.8934,0,211.299-68.8917,246.4746-176.0898-51.9758,89.7861-148.9627,150.215-260.1538,150.215" style={{ fill: "none" }} />
                </clipPath>
                <linearGradient id="e" x1="-3401.3718" y1="684.6553" x2="-3396.5552" y2="684.6553" gradientTransform="translate(-507729.6052 102822.7747) rotate(180) scale(149.4892)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#e6332a" />
                    <stop offset=".1" stopColor="#e6332a" />
                    <stop offset=".2161" stopColor="#ec5b2c" />
                    <stop offset=".4753" stopColor="#f9b233" />
                    <stop offset=".9" stopColor="#e6332a" />
                    <stop offset="1" stopColor="#e6332a" />
                </linearGradient>
                <clipPath id="f">
                    <path d="M413.6743,425.8628c-111.1814,0-208.2068,60.4289-260.1393,150.2102-21.2074,36.6302-46.0562,78.1588-53.9699,122.4571v1.9121h300.43c111.191,0,208.1779-60.4578,260.1538-150.2294,25.5712-44.1922,40.286-95.4793,40.286-150.2151,0-51.2485-12.894-99.4481-35.5272-141.6414-1.5943-2.9767-3.1789-5.8523-4.7588-8.5832-35.1756,107.2077-111.5715,176.0898-246.4746,176.0898" style={{ fill: "none" }} />
                </clipPath>
                <radialGradient id="g" cx="-3393.665" cy="669.9235" fx="-3393.665" fy="669.9235" r="4.8166" gradientTransform="translate(-400127.3747 79760.4201) rotate(-180) scale(118.1101)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#f9b233" />
                    <stop offset=".2384" stopColor="#f9b233" />
                    <stop offset=".8517" stopColor="#e6332a" />
                    <stop offset="1" stopColor="#e6332a" />
                </radialGradient>
            </defs>
            <g style={{ clipPath: "url(#b)" }}>
                <rect x="147.9153" y="-63.8329" width="463.8835" height="627.2115" transform="translate(21.7512 529.8408) rotate(-71.355)" style={{ fill: "url(#c)" }} />
            </g>
            <g style={{ clipPath: "url(#d)" }}>
                <rect x="20.8242" y="124.2374" width="718.0656" height="699.8233" transform="translate(-212.2952 338.2649) rotate(-38.3764)" style={{ fill: "url(#e)" }} />
            </g>
            <g style={{ clipPath: "url(#f)" }}>
                <rect x="81.3101" y="113.5386" width="637.3797" height="723.1378" transform="translate(-187.5639 676.3434) rotate(-68.8114)" style={{ fill: "url(#g)" }} />
            </g>
        </svg>
    );
}


export const Interaction = forwardRef<AnimationItem, LottieProps>(({ color, loop = false, autoplay = false }: LottieProps, fref) => {
    const container = useRef<HTMLDivElement>(null);
    const [ref, setRef] = useState<AnimationItem | null>(null);
    useEffect(() => {
        if (!container.current) return;
        const icon = lottie.loadAnimation({
            loop, autoplay,
            container: container.current,
            renderer: "svg",
            path: assetPath("/data/icon-interact.json")
        });
        setRef(icon);
        return () => icon.destroy();
    }, [container, loop, autoplay]);
    useImperativeHandle(fref, () => ref!, [ref]);
    return (
        <div ref={container} className={styles.lottie} style={{ stroke: color }} />
    );
});